import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=d9bded5c&scoped=true&"
import script from "./automatic.vue?vue&type=script&lang=js&"
export * from "./automatic.vue?vue&type=script&lang=js&"
import style0 from "./automatic.vue?vue&type=style&index=0&id=d9bded5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bded5c",
  null
  
)

export default component.exports